// Shared date helpers for Analytics + Comparativas.

const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export function fmt(d: Date): string {
  // Local date → YYYY-MM-DD (avoid UTC shift from toISOString)
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export interface DateRange {
  from: string;
  to: string;
}

function monthRange(year: number, month: number): DateRange {
  // month: 0-11
  return { from: fmt(new Date(year, month, 1)), to: fmt(new Date(year, month + 1, 0)) };
}

function yearRange(year: number): DateRange {
  return { from: fmt(new Date(year, 0, 1)), to: fmt(new Date(year, 11, 31)) };
}

// Label for a month range like "Mayo 2025"
export function rangeLabel(range: DateRange): string {
  const f = new Date(range.from + 'T00:00:00');
  const t = new Date(range.to + 'T00:00:00');
  const sameMonth = f.getFullYear() === t.getFullYear() && f.getMonth() === t.getMonth();
  const isFullMonth = sameMonth && f.getDate() === 1 && t.getDate() === new Date(t.getFullYear(), t.getMonth() + 1, 0).getDate();
  const isFullYear = f.getMonth() === 0 && f.getDate() === 1 && t.getMonth() === 11 && t.getDate() === 31 && f.getFullYear() === t.getFullYear();
  if (isFullYear) return String(f.getFullYear());
  if (isFullMonth) return `${MONTH_NAMES[f.getMonth()]} ${f.getFullYear()}`;
  return `${range.from} → ${range.to}`;
}

// Shift a month range by N months
export function shiftMonths(range: DateRange, months: number): DateRange {
  const f = new Date(range.from + 'T00:00:00');
  return monthRange(f.getFullYear(), f.getMonth() + months);
}

// Shift a range by N years (keeps month/day structure of a month or year range)
export function shiftYears(range: DateRange, years: number): DateRange {
  const f = new Date(range.from + 'T00:00:00');
  const t = new Date(range.to + 'T00:00:00');
  return {
    from: fmt(new Date(f.getFullYear() + years, f.getMonth(), f.getDate())),
    to: fmt(new Date(t.getFullYear() + years, t.getMonth(), t.getDate())),
  };
}

export { monthRange, yearRange };
